export const en = {
    autotargeting: 'Autotargeting',
    campaign: 'Campaign',
    clicks: 'Clicks',
    'clicks-forecast': 'Estimated clicks',
    cost: 'Spending, {currency}',
    'cost-forecast': 'Estimated spending, {currency}',
    name: 'Group'
};
